import { getTypeList } from "@/api/index.js";
import { ORIGIN_LIST } from '@/api/origin'

/**
 * 项目类目模块
 * 保存 layout/index.vue 中 getTypeList 获取的数据
 * 并提供根据 id 获取数据的方法
 */
const state = {
  // 指数索引列表
  menuList: []
};

const mutations = {
  SET_MENU_LIST(state, list) {
    state.menuList = list;
  }
};

const actions = {
  /**
   * 获取项目类目列表并保存到 store
   * 已有数据时不再重复请求
   * @returns {Promise<Array>}
   */
  getMenuList({ commit, state }) {
    if (state.menuList.length > 0) {
      return Promise.resolve(state.menuList);
    }
    return getTypeList({ parentId: 0, status: 1 }).then((res) => {

      res.rows = res.rows.map(item => {

        const p = ORIGIN_LIST.find(v => v.name === item.memo)
        if (p) {
          item.platformType = p.type
        } else {
          item.platformType = 'cloud'
        }
        return item
      })
      commit("SET_MENU_LIST", res.rows || []);
      return state.menuList;
    });
  }
};

const getters = {
  /**
   * 根据 id 获取单条类目数据
   * 用法：this.$store.getters['type/getTypeById'](id)
   * @returns {Function} (id) => item
   */
  getTypeById: (state) => (id) => {
    return state.menuList.find((item) => String(item.id) === String(id));
  },
  /**
   * 获取第一条类目数据
   * 用法：this.$store.getters['type/getFirstType']
   * @returns {Object|null}
   */
  getFirstType: (state) => {
    return state.menuList.length > 0 ? state.menuList[0] : null;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
